import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]

import { Faction } from '@/typings/faction';
import { computed, onMounted, PropType, ref, toRefs } from 'vue';
import DefaultImage from '@/assets/images/defaultGroup.svg';


export default /*#__PURE__*/_defineComponent({
  props: {
  faction: {
    type: Object as PropType<Faction>,
    required: true,
  },
},
  setup(__props) {

const props = __props



const { faction } = toRefs(props);

const path = computed(
  () => process.env.VUE_APP_IMAGE_PATH + faction.value.ImageName
);

const src = ref<string>();

function loadDefaultImage() {
  src.value = DefaultImage;
}

onMounted(() => {
  src.value = path.value;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: "w-full h-full bg-cover bg-center border-2 border-primary rounded-full",
      style: _normalizeStyle({
        'background-image': `url(${src.value})`,
      })
    }, [
      _createElementVNode("img", {
        class: "hidden",
        src: src.value,
        onError: loadDefaultImage
      }, null, 40, _hoisted_1)
    ], 4)
  ]))
}
}

})